export default {
    name: 'หน้าจอตั้งใจเรียน',
    studentMessage: 'ตอนนี้ตั้งใจฟังคุณครูกันนะ',
    teacherMessage: 'กำลังใช้หน้าจอตั้งใจเรียนอยู่',
    close: 'เลิกใช้งาน',
};
